import { Col3Col9, ColHalves, ISelectOption, Loading, Select } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { CustomQuestionPropertyUnderValidation, IValidationResult } from '../../../models';
import { ColFull, LoadingWrapper, Section } from '../../common';
import { SurveyHelper, ValidationCollectionHelper } from '../../../utilities';
import { connect, useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../../store';
import { ActionCreators as CommonHierarchyActionCreators } from '../../../store/CommonHierarchyStore';
import { ActionCreators as CustomQuestionActionCreators } from '../../../store/CustomQuestionStore';
import { ActionCreators } from '../../../store/ExternalHierarchyStore';
import { useEffect } from 'react';
import { HierarchyNodeActionCreator, SelectHierarchy as CommonHierarchyView } from '@aon/tws-common-ui-hierarchy';
import Constants from '../../../constants';

export interface IHierarchyResponseOptionSectionProps {
	loading: boolean;
	surveyId: number;
	hierarchyId?: string;
	sectionContainer?: any;
	validationResult?: IValidationResult;
	HandleSetOpenEnded: () => void;
	HandleSetTextBox: () => void;
	HandleResponseOptionGroupChange: (responseOptionGroupId: number) => void;
}

export const ResponseOptionsWrapper = styled('div').attrs<{}>({
	className: 'tws-hierarchy-response-options-selector',
})`
	margin: 10px 0;
	.tws-col3col9-left {
		text-align: center;
		margin: 10px 0;
	}
`;

export const HierarchyUploadWrapper = styled('div').attrs<{}>({
	className: 'tws-hierarchy-response-options-section',
})`
	padding: 10px 30px;
`;
export const HierarchyView = styled(CommonHierarchyView)`
	& .tws-selected-hierarchy-container {
		display: none;
	}
`;

export function HierarchyResponseOptionSection(props: IHierarchyResponseOptionSectionProps) {
	const { loading, hierarchyId, sectionContainer } = props;
	const { customQuestion, externalHierarchy, Hierarchy } = useSelector((storeState: IApplicationState) => storeState);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(ActionCreators.GetHierarchies(false));
		if (hierarchyId) {
			dispatch(CommonHierarchyActionCreators.GetHierarchyVm(hierarchyId, true));
		}
	}, []);

	function handleHierarchySelection(value?: string | string[]) {
		if (value !== undefined && !Array.isArray(value)) {
			dispatch(CustomQuestionActionCreators.HandleHierarchyChange(value));
			dispatch(CommonHierarchyActionCreators.GetHierarchyVm(value, true));
		}
	}

	const Container = sectionContainer ? sectionContainer : Section;
	let hierarchies: ISelectOption[] = [];
	if (!externalHierarchy.hierarchyMetadatas.isLoading && !externalHierarchy.hierarchyMetadatas.couldNotFetchData) {
		// Filter out hierarchies that not Person(0) and Positional(1)
		const filteredHierarchies = _.filter(
			externalHierarchy.hierarchyMetadatas,
			(hierarchy) => hierarchy.hierarchyType !== 0 && hierarchy.hierarchyType !== 1,
		);
		hierarchies = SurveyHelper.getSelectOptionsFromHierarchyAttributes(filteredHierarchies);
	}
	const validationHelper = new ValidationCollectionHelper<CustomQuestionPropertyUnderValidation>(customQuestion.validationResults);
	const validationResult = validationHelper.GetValidationResultForProperty(CustomQuestionPropertyUnderValidation.hierarchy);
	const showError = (validationResult && !validationResult.isValid) || false;
	const messages = !validationResult ? '' : validationResult.errors || [];
	return (
		<Container id='choose-custom-responseoptions' sectionHeader={ContentConstants.SECTIONHEADERS_CUSTOM_QUESTION_CHOOSE_RESPONSEOPTION}>
			<ColFull>{ContentConstants.INSTRUCTIONALTEXT_HIERARCHY_CREATE_RESPONSEOPTION}</ColFull>
			{loading && (
				<LoadingWrapper>
					<Loading height={'70px'} width={'70px'} />
				</LoadingWrapper>
			)}
			{!loading && (
				<>
					<ColHalves
						Col1={
							<ResponseOptionsWrapper>
								<Col3Col9
									label={ContentConstants.CUSTOM_RESPONSE_OPTION_LABEL_HIERARCHY}
									className='tws-custom-response-hierarchy-container'
								>
									<Select
										className='tws-custom-response-hierarchy-placement'
										selectSize='lg'
										displayText={ContentConstants.CUSTOM_RESPONSE_OPTION_PLACEHOLDER_HIERARCHY}
										items={hierarchies}
										selectedValue={hierarchyId}
										error={showError}
										message={messages}
										onApply={handleHierarchySelection}
									/>
									{externalHierarchy.hierarchyMetadatas.isLoading && <Loading height='30px' width='30px' />}
								</Col3Col9>
							</ResponseOptionsWrapper>
						}
						Col2={<></>}
					></ColHalves>
					<ColFull>
						<HierarchyViewContainer
							{...props}
							{...Hierarchy}
							onChangeSelectionCriteria={() => {
								/* */
							}}
							selectAll={false}
							disabled={true}
							disableSelectAll={true}
							hideselectItemRadioButtons={true}
							hideClearButton={true}
							hideCheckboxes={true}
							hideSelectType={true}
						/>
					</ColFull>
				</>
			)}
		</Container>
	);
}

const hierarchyNodeActionCreator = new HierarchyNodeActionCreator(Constants.ORGMANAGER_HIERARCHIES_URL, false);
export const HierarchyViewContainer = connect(
	(state: IApplicationState) => ({
		hierarchy: state.Hierarchy,
	}),
	{
		...hierarchyNodeActionCreator,
	},
)(HierarchyView) as any;
